import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { ImportsModule } from "../../../../imports";
import { LenguageSwitcher } from "../../../shared/lenguage-switcher/lenguage-switcher";
import { LoginBaseComponent } from "../login.base.component";
import { ReloginScreenComponent } from "../reloginscreen.component";


@Component({
    standalone: true,
    selector: 'app-login-gisecloud',
    templateUrl: `login.gisecloud.component.html`,
    styleUrls: ['./login.gisecloud.component.scss'],
    imports: [FormsModule, RecaptchaModule, ImportsModule, LenguageSwitcher, ReloginScreenComponent],
})
export class LoginGisecloudComponent extends LoginBaseComponent {

    logoform = "/assets/cecopin/GISECloud-2.png"
    logoheader = "/assets/cecopin/cecopin-hierro.png"

}